"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const StyledCheckboxContainer = styled_components_1.default.div `
  display: inline-block;
`;
const StyledLabel = styled_components_1.default.label `
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  position: relative;
  ${({ isDisabled }) => isDisabled &&
    (0, styled_components_1.css) `
      pointer-events: none;
      opacity: 0.4;
    `}
`;
const StyledMarkContainer = styled_components_1.default.span `
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  transition: background-color 0.1s ease-out;

  &:hover {
    background-color: ${({ theme }) => theme.neutral.lighter};
  }
`;
const StyledMark = styled_components_1.default.span `
  display: inline-block;
  position: relative;
  border: 2px solid ${({ theme }) => theme.neutral.main};
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  left: 0;
  border-radius: 4px;

  ${({ isMinusIcon }) => isMinusIcon
    ? (0, styled_components_1.css) `
          &::after {
            content: "";
            width: 12px;
            height: 2px;
            background-color: white;
            display: block;
            opacity: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        `
    : (0, styled_components_1.css) `
          &::after {
            content: "";
            width: 10px;
            height: 5px;
            display: block;
            border: 2px solid ${({ theme }) => theme.white};
            border-top: none;
            border-right: none;
            opacity: 0;
            position: absolute;
            transition: all 110ms;
            transform: rotate(-45deg);
            top: 0;
            left: 0;
            bottom: 3px;
            right: 0;
            margin: auto;
          }
        `}
`;
const Span = styled_components_1.default.span `
  margin-left: 8px;
  font-weight: ${({ isBoldLabel }) => (isBoldLabel ? "bold" : "medium")};
`;
const StyledInput = styled_components_1.default.input `
  position: absolute;
  visibility: hidden;
  display: none;
  :checked {
    ~ ${StyledMarkContainer} > ${StyledMark} {
      border-color: ${({ theme }) => theme.primary.main};
      background-color: ${({ theme }) => theme.primary.main};
      ::after {
        opacity: 1;
      }
    }

    &:disabled {
      ~ ${StyledMarkContainer} > ${StyledMark} {
        border-color: ${({ theme }) => theme.neutral.main};
        background-color: ${({ theme }) => theme.neutral.main};
      }
    }
  }
`;
const RotaCheckbox = ({ id, name, isDisabled = false, isChecked = false, label, onClick, style, isBoldLabel = false, isMinusIcon = false }) => {
    return (react_1.default.createElement(StyledCheckboxContainer, null,
        react_1.default.createElement(StyledLabel, { isDisabled: isDisabled },
            react_1.default.createElement(StyledInput, { id: id, name: name, style: Object.assign({}, style), disabled: isDisabled, type: "checkbox", onChange: onClick, checked: isChecked }),
            react_1.default.createElement(StyledMarkContainer, null,
                react_1.default.createElement(StyledMark, { isMinusIcon: isMinusIcon })),
            label && react_1.default.createElement(Span, { isBoldLabel: isBoldLabel }, label))));
};
exports.default = RotaCheckbox;
